import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
export interface Testimonial {
  initials: string;
  quote: string;
  name: string;
  location: string;
  role: string;
  highlight?: string;
}
interface TestimonialsSectionProps {
  title?: string;
  testimonials: Testimonial[];
  darker?: boolean;
}
export function TestimonialsSection({
  title,
  testimonials,
  darker = false
}: TestimonialsSectionProps) {
  return <section className={`py-20 px-4 sm:px-6 lg:px-8 ${darker ? 'bg-navy-900' : 'bg-navy-800'}`} data-id="element-280">
      <div className="max-w-7xl mx-auto" data-id="element-281">
        {title && <motion.h2 initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.3
      }} className="text-3xl md:text-4xl font-bold text-center mb-12" data-id="element-282">
            {title}
          </motion.h2>}

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-283">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 15
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-30px'
        }} transition={{
          delay: i * 0.05,
          duration: 0.3
        }} className="bg-navy-700/40 border border-navy-600 rounded-2xl p-6 flex flex-col h-full relative overflow-hidden" data-id="element-284">
              {/* Subtle glow */}
              <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/5 rounded-full blur-2xl" data-id="element-285" />

              <div className="flex items-center gap-4 mb-4" data-id="element-286">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-blue-500 to-blue-700 flex items-center justify-center text-white font-bold text-lg shadow-lg" data-id="element-287">
                  {t.initials}
                </div>
                <div data-id="element-288">
                  <div className="flex text-gold-400 mb-1" data-id="element-289">
                    {[...Array(5)].map((_, idx) => <Star key={idx} className="w-4 h-4 fill-current" data-id="element-290" />)}
                  </div>
                  {t.highlight && <span className="text-xs font-semibold text-blue-300 bg-blue-900/50 px-2 py-0.5 rounded" data-id="element-291">
                      {t.highlight}
                    </span>}
                </div>
              </div>

              <p className="text-slate-300 italic mb-6 flex-grow relative z-10" data-id="element-292">
                "{t.quote}"
              </p>

              <div className="mt-auto pt-4 border-t border-navy-600/50" data-id="element-293">
                <p className="font-semibold text-white" data-id="element-294">{t.name}</p>
                <p className="text-sm text-slate-400" data-id="element-295">
                  {t.location} · {t.role}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}